import React, {Component, useEffect, useState} from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import {alertActions, commonActions, contracterActions, inboxActions, modalActions} from '../../../../store/actions'

import CertificateList from './CertificateInboxList'
import Calendar from '../../../../module/component-box/Calendar'

import queryString from 'query-string';
import Pagination from "../../../../module/pagination-box";
import history from "../../../../route/history";
import CertificateHelpBox from "../modal/CertificateHelpBox";
import CerficateReceiverModal from "../modal/CerficateReceiverModal";

import ServiceDashboard from '../../../../layout/service/ServiceDashBoard' // 2021.05 DashBoard 추가

const CertificateInbox = (props) => {
  const [state, setState] = useState({});
  const [searchWord, setSearchWord] = useState("");

  const [searchInfo, setSearchInfo] = useState([
    {type: 'tab', value: '99'},
    {type: 'type', value: 'ALL'}
  ]);

  const [toggle, setToggle] = useState({
    isSearchType: false,
    isDocType: false,
    isHelp: false,
  })
  const [countInfo, setCountInfo] = useState({
    countALL: 0,
    count03: 0,
    count10: 0,
    count11: 0,
    count12: 0
  });

  const [tabId, setTabId] = useState('99')
  
  const searchSubject = [
    {title: '전체', id: 'ALL'},
    {title: '조회기간', id: 'TERM'},
    {title: '증명서종류', id: 'KIND'}
  ]
  const [pagingInfo, setPagingInfo] = useState({});
  const [printList, setPrintList] = useState([]);

  useEffect(() => {
    props.common({mainCd: ['CRT_STS_CD', 'CRT_DV']});

    const query = queryString.parse(history.location.search);
    console.log('query = ', query);

    if (Object.keys(query).length > 0) {
      props.settingHistory(query);

      setSearchInfo([
        {type: 'tab', value: query.tabStatus},
        {type: 'type', value: query.selectedSubject},
        {type: 'doc', value: query.srhKind},
        {type: 'from', value: query.srhFrom},
        {type: 'to', value: query.srhTo},
        {type: 'order', value: query.srhOrder},
        {type: 'by', value: query.srhBy},
        {type: 'searchWord', value: query.searchWord}
      ]);
      if (query.searchWord) {
        setSearchWord(query.searchWord);
      }
    } else {
      searchList(searchInfo);
    }

    return () => {
      props.changeSearchInfo(null); // 이전 검색 초기화
    }
  }, []);

  // count갯수 설정...
  useEffect(() => {
    setCountInfo({
      ...countInfo,
      countALL: props.countInfo?.ALL,
      count03: props.countInfo?.["03"],
      count10: props.countInfo?.["10"],
      count11: props.countInfo?.["11"],
      count12: props.countInfo?.["12"],
    })
  }, [props.countInfo]);

  // 증명서 유형 공통코드에서 온거 그대로 셋팅

  // 검색조건 단건 변경시
  useEffect(() => {
    if (props.soloSelectInfo === null || props.soloSelectInfo === undefined) return;
    console.log('props.soloSelectInfo = ', props.soloSelectInfo);
    let arr = searchInfo.filter((info) => info.type !== props.soloSelectInfo?.type)

    arr.push(props.soloSelectInfo)

    if (props.soloSelectInfo?.type === 'type') {
      if (props.soloSelectInfo?.value === 'TERM') {
        arr = arr.filter((info) => info.type !== 'doc')
        arr.push({type: 'doc', value: ''})
      } else if (props.soloSelectInfo?.value === 'KIND') {
        arr = arr.filter((info) => info.type !== 'to' && info.type !== 'from')
        arr.push({type: 'to', value: ''}, {type: 'from', value: ''})
      } else {
        arr = arr.filter((info) => info.type !== 'to' && info.type !== 'from' && info.type !== 'doc')
        arr.push({type: 'to', value: ''}, {type: 'from', value: ''}, {type: 'doc', value: ''})
      }
    }

    if (props.soloSelectInfo?.type === 'order') {
      let tmpArr = arr.filter((info) => info.type == 'by')
      if(tmpArr.length > 0) {
        arr = arr.filter((info) => info.type !== 'by')
        if(tmpArr[0]['value'] === 'desc') {
          arr.push({type:'by', value:'asc'});
        }else {
          arr.push({type:'by', value:'desc'});
        }
      }else {
        arr.push({type:'by', value:'desc'});
      }
    }

    console.log('arr = ', arr);
    setSearchInfo(arr);

    searchList(arr);

  }, [props.soloSelectInfo]);

  // 검색결과 리스트 response시
  useEffect(() => {
    setPagingInfo({
      totalRecords: (props.inboxList?.totalElements ? props.inboxList?.totalElements : 0),
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.inboxList?.pageable?.pageNumber,
      pagesToShow: 10
    })

    setPrintList(props.inboxList?.content);

  }, [props.inboxList])

  // 히스토리 존재시 검색조건 셋팅
  useEffect(() => {
    if (!props.history) return;

    const idx = props.history?.pageIdx ? props.history?.pageIdx : 0

    searchList(null, idx);
  }, [props.history])

  const searchTabInfo = [
    {
      title: '전체',
      id: '99',
      count: countInfo.countALL
    },
    {
      title: '발급완료',
      id: '03',
      count: countInfo.count03
    },
    {
      // title: '제출',
      title: '안 읽음',
      id: '10',
      count: countInfo.count10
    },
    {
      title: '반려',
      id: '11',
      count: countInfo.count11
    },
    {
      // title: '수취완료',
      title: '읽음',
      id: '12',
      count: countInfo.count12
    }
  ];

  // 조건 단건 변경시
  const onSelected = (e, type, value) => {
    let changedObj = {
      type: type,
      value: value
    };
    if(type === 'tab') {
      setTabId(value)
    }

    props.changeSearchInfo(changedObj);
  }

  const searchList = (searchInfo, index = 0) => {
    let sendSearch = {};

    if (searchInfo === null) {
      // history 남아있을시
      sendSearch = {
        srhFrom: props.history?.srhFrom,
        srhTo: props.history?.srhTo,
        srhKind: props.history?.srhKind,
        selectedSubject: props.history?.selectedSubject ? props.history?.selectedSubject : 'ALL',
        tabStatus: props.history?.tabStatus ? props.history?.tabStatus : '99',
        srhOrder: props.history?.srhOrder ? props.history?.srhOrder : '',
        srhBy: props.history?.srhBy ? props.history?.srhBy : 'desc',
        searchWord: props.history?.searchWord ? props.history?.searchWord : '',
      }
    } else {
      sendSearch = {
        srhFrom: searchInfo.find(s => s.type === 'from')?.value || '',
        srhTo: searchInfo.find(s => s.type === 'to')?.value || '',
        srhKind: searchInfo.find(s => s.type === 'doc')?.value || '',
        selectedSubject: searchInfo.find(s => s.type === 'type')?.value || '',
        tabStatus: searchInfo.find(s => s.type === 'tab')?.value || '',
        srhOrder: searchInfo.find(s => s.type === 'order')?.value || '',
        srhBy: searchInfo.find(s => s.type === 'by')?.value || '',
        searchWord: searchInfo.find(s => s.type === 'searchWord')?.value || ''
      }
    }

    sendSearch.pageIdx = index;

    setState({
      ...state,
      ...sendSearch
    });

    let paramStr = queryString.stringify(sendSearch);
    paramStr.length > 0 && (paramStr = "?" + paramStr)
    // history.location.search = '/service/inbox' + paramStr;
    history.push('/service/inbox' + paramStr);

    props.readInboxList(sendSearch);
  }

  // 선택으로 상세 페이지 전환
  const onInboxDetail = (contract) => {
    const status = contract.sts;
    
    props.selectInboxInfo(contract); // 선택한 대상의 정보 셋팅

    if (status === "01") { // 임시저장 - 발급화면 호출
      window.location.href = '/service/apply/1?seq=' + contract.crtSeq;
    } else if (status === "02" || status === "04") { // 전송완료,오류통보 - 발급화면 readonly상태로 호출
      history.push({pathname: '/service/apply/detail/' + contract.crtSeq, state: state})
    } else if (status === "03" || status === "10" || status === "11" || status === "12") { // 발급완료, 제출완료, 수취완료, 반려 - 상세조회화면 조회로 호출
      history.push({pathname: '/service/inbox/detail/' + contract.crtRcvSeq, state: state})
    }
  }

  const onInboxSubmit = (checkedObjs) => {
    //props.selectInboxInfo(checkedCrtSeq); // 선택한 대상의 정보 셋팅

    //history.push({pathname: '/service/inbox/submit', state: state})
    props.showModalBagic(checkedObjs);
  }

  const toggleHelp = () => {
    setToggle({...toggle, isHelp: !toggle.isHelp});
  }
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onSelected(e, 'searchWord', searchWord);
    }
  }
  return (
      <>
         <div className="ServiceDashboard">
           <ServiceDashboard />

           <div className="component-box">
             <div className="tab-box">
                 <div className="tab-component">
                   <ul>
                     {
                       searchTabInfo.map((item, index) =>
                       <li key={index}>
                             <a href="./"
                                className={`${searchInfo.find(i => i.type === 'tab').value === item.id ? 'active' : ''}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onSelected(e, 'tab', item.id);
                                }}
                                title={item.title}
                             > {item.title}
                               {
                                 item.count >= 0 ? <span> {item.count}</span> : ''
                               }
                                {/*<i className="badge_new">N</i>*/}
                             </a>
                           </li>
                       )
                     }
                   </ul>
                 </div>

                 <div className="sch-box__btn">
                      <button type="button" className="bt_sch_search"
                      onClick={() => setToggle({
                         ...toggle,
                         isSearchType: !toggle.isSearchType
                       })}
                      >
                         <span>검색</span>
                      </button>
                 </div>

             </div>
           </div>

           { /*dash board */ }
         </div>

         {
          toggle.isSearchType ?
          <div className="service-search-box">
            <div className="container">
              <>
              <div className="col datepicker">
                  <Calendar
                      onSelect={(value) =>
                          onSelected(null, 'from', value ? moment(value).format('Y-MM-DD') : '')
                      }
                      default={searchInfo?.find(i => i.type === 'from')?.value}
                      title="처음날짜"
                  />
                  <span className="divider">~</span>
                  <Calendar
                      onSelect={(value) =>
                          onSelected(null, 'to', value ? moment(value).format('Y-MM-DD') : '')
                      }
                      default={searchInfo?.find(i => i.type === 'to')?.value}
                      title="마지막날짜"
                  />
              </div>

              <div className="col input-with-icon">
               <input type="text"
                    title="검색"
                    className="form-control input-text"
                    placeholder="검색어 입력"
                    value={searchWord}
                    onChange={({ target }) => setSearchWord(target.value)}
                    onKeyPress={handleKeyPress}
               />
               <span className="icon-search"
                   alt="검색"
                  //  onClick={() => searchList(searchInfo)}
                  onClick={e => onSelected(e, 'searchWord', searchWord)}
               />
              </div>
              </>
            </div>
          </div>
          : ''
          }

        <div className="content">
          {toggle.isHelp && <CertificateHelpBox onClose={toggleHelp} text="받은 증명서를 확인 할 수 있습니다."/>}
          <h4 className="tit-lev0 blind">증명서 수신함
            <span className="btn-help" onClick={toggleHelp}>도움말</span>
          </h4>

          <CertificateList
              data={printList}
              commoncode={props.commoncode}
              onInboxDetail={onInboxDetail}
              onInboxSubmit={onInboxSubmit}
              reload={props.readInboxList}
              tabId={tabId}
              />
          <Pagination
              pagingInfo={pagingInfo}
              onChange={(param) => searchList(searchInfo, param - 1)}
          />
          <CerficateReceiverModal
          />
        </div>
      </>
  )
}

const mapStateToProps = state => {
  return {
    soloSelectInfo: state.inbox?.selectInfo,
    inboxList: state.inbox?.inboxList?.list,
    countInfo: state.inbox?.inboxList?.count,
    commoncode: state.commoncode?.co,
    history: state.inbox?.history
  }
}

const actionCreators = {
  changeSearchInfo: inboxActions.changeSearchInfo,
  readInboxList: inboxActions.readInboxList,
  selectInboxInfo: inboxActions.selectInboxInfo,
  common: commonActions.getCommonCode,
  settingHistory: inboxActions.settingHistory,
  showModalBagic: modalActions.showModalBagic,
  error: alertActions.error,
}

export default connect(
  mapStateToProps,
  actionCreators
)(CertificateInbox)
